const map = {
	"./Screenshot_1789959006.png": 652,
	"./Screenshot_1789959009.png": 315,
	"./Screenshot_1789959021.png": 1,
	"./Screenshot_1789959031.png": 410,
	"./Screenshot_1789959040.png": 590
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 241;